export default __webpack_public_path__ + "static/media/insta-3-comp.6eef3845.jpg";